export const environment = {
  production: true,
  baseUrl: "https://kobize.ekowitryna.pl",
  apiUrl: "https://server.bdomobile.com",
  accountsApiUrl: "https://server.bdomobile.com/accounts",
  authApiUrl: "https://server.bdomobile.com/uaa",
  keycloakUrl: "https://auth.mobiletract.com",
  adminPanelUrl: "https://admin.ekowitryna.pl",
  platformWebUrl: "https://platforma.ekowitryna.pl",
  webPanelUrl: "https://panel.bdomobile.com",
  realm: "bdo-mobile",
  clientId: "ekowitryna_kobize_web",
  googleTagManagerId: 'GTM-W68KSTQZ',
  googleTagManagerPreview: 'env-1',
  googleTagManagerAuth: 'hbeELSzWf2rM-2R-s9Vung',
  bypassAuth: false
};